import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import { architeckCall } from 'database';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Container } from "reactstrap";
import { toggleAlert } from 'store/functions/system';
import { getUrlParameter } from 'utils/urls';
import NavSelector from './ComponentsView/NavSelector';
import ProjectSummary from './ComponentsView/ProjectSummary';
import ProjectWork from './ComponentsView/ProjectWork';
import ReportBug from './ComponentsView/ReportBug';
import RequestUpdate from './ComponentsView/RequestUpdate';


class ProjectsView extends React.Component {

    state = {
        navPill: 1,
        project: {},
        project_logs_clients: [],
    }

    setNavPill = () => {

        const navPill = getUrlParameter('nav')

        if(navPill) {
            this.setState({navPill: parseInt(navPill)})
        }

    }

    toggleNavs = (e,  index) => {
        e.preventDefault();
        this.setState({ navPill: index });
    };


    componentWillMount = () => {

        const found_project = this.setProject()
        this.setProjectClientLogs(found_project);
        this.setNavPill()

    }

    setProject = () => {

        const _id = this.props.match.params._id;
        const found_project = this.props.app_projects.find(a => a._id === _id);

        if(found_project) {
            this.setState({project: found_project});
            return found_project
        }

    }

    setProjectClientLogs = async (found_project) => {

        const project_logs_clients = await architeckCall({
            method: 'get',
            url: `/api/v1/project_logs_clients/list?find_by=project__${found_project._id}`
        })

        if(project_logs_clients.success) {

            this.setState({project_logs_clients: project_logs_clients.data})

        } else {

            toggleAlert(true, 'danger', 'Something went wrong fetching data for this project', 'infinite' )


        }


    }
    
    render() {

        const project_logs_clients = this.state.project_logs_clients;
        const project = this.state.project;

        return (
            <>

            <Container>

                <Helmet>
                    <title>{project.name}</title>
                    <meta name="description" content={project.name} />
                </Helmet>

                {this.state.ModalCreate}


                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/dashboard" 
                    title={<span>{this.state.project.name}</span>} breadcrumb_1={this.state.project.company.name}
                   
                />

              

                    <NavSelector navPill={this.state.navPill} toggleNavs={(e, index) => this.toggleNavs(e, index)} />

                    {this.state.navPill === 1 ? 
                        <ProjectSummary
                            project={project}
                        />
                    : null}

                    {this.state.navPill === 2 ? 
                        <ProjectWork
                            project_logs_clients={project_logs_clients}
                        />
                    : null}
                    {this.state.navPill === 3 ? 
                        <RequestUpdate
                            project={project}
                        />
                    : null}
                    {this.state.navPill === 4 ? 
                        <ReportBug
                            project={project}
                        />
                    : null}

                 

                </Container>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        app_users: state.users.app_users,
        app_projects: state.projects.app_projects,  
    };
};

export default connect(mapStateToProps, '')(ProjectsView);

